(function () {
  let tries = 0;
  const timer = setInterval(() => {
    const store = window.__pagefly_helper_store__;
    if (!store && ++tries < 100) return;
    clearInterval(timer);
    if (!store) return;

    store.subscribe(async (item) => {
      if (!item?.id) return;
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      await drawer.handleCartRender();
      window.eventBus.emit('open:cart:drawer', { scrollToTop: true });

      const cart = await (await fetch('/cart.js')).json();
      window.wetheme.updateCartCount(cart);
    });
  }, 100);
})();
